import { useHistory, useLocation } from 'react-router-dom';

/**
 * Manages query parameters for the Aisle Content page.
 *
 * @returns {Object} - Hook return object
 * @returns {Object} queryParams - The query parameters
 * @returns {Object} queryParamsData - The query parameters data
 * @returns {Function} updateQueryParams - Callback function to update the query parameters
 */
export function useAisleContentQueryParams() {
    const history = useHistory();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const updateQueryParams = (params) => {
        Object.entries(params).forEach(([key, value]) => {
            if (value != null) {
                queryParams.set(key, String(value));
            } else {
                queryParams.delete(key);
            }
        });
        history.replace({ ...location, search: queryParams.toString() });
    };

    const queryStringDate = queryParams.get('date');
    const date = queryStringDate ? new Date(`${queryStringDate}T00:00:00`) : undefined;

    const queryStringPackGroupID = queryParams.get('packGroupID');
    const packGroupID = queryStringPackGroupID ? parseInt(queryStringPackGroupID, 10) : undefined;

    return {
        queryParams,
        queryParamsData: {
            date,
            packGroupID,
        },
        updateQueryParams,
    };
}

/**
 * Converts a Date to a query string of the format YYYY-MM-DD.
 *
 * @param {Date} date - The Date to convert
 * @returns {string} The query string of the format YYYY-MM-DD
 */
export function convertDateToQueryString(date) {
    return date.toISOString().split('T')[0];
}
